export const price = msg => (value, values) => {
  const regex = /^\d*(.\d{0,2})?$/;
  if (!regex.test(value)) {
    return msg || 'Invalid';
  }
};
